import styled from "styled-components";
import EmployeesWrapper from "../../layout/EmployeesWrapper";


function EmployeesPage() {

  return (
    <EmployeesWrapper
      title={'Employees and Payroll'}
    >

      <h1>Home</h1>
    </EmployeesWrapper>
  );
}

export default EmployeesPage;

const StyledEmployees = styled.div`

`;